module.exports = "//static.hsappstatic.net/LoginUI/static-1.9261/img/warning.svg"